import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import './KioskStyles.scss';

export default function KioskRootMessage() {
  return (
    <Box className="kiosk-root-message">
      <Container maxWidth="md" sx={{ textAlign: 'center' }}>
        <Typography variant="h3" component="h1" sx={{ mb: 2, fontWeight: 'bold' }}>
          Welcome to Welbee Kiosk
        </Typography>
        <Typography variant="h5" sx={{ mb: 1, fontSize: '1.5rem' }}>
          Please use your school's kiosk URL
        </Typography>
        <Typography variant="body1" sx={{ fontSize: '0.875rem'}}>
          Format: <strong><i><u>kiosk.welbee.co.uk/school-name</u></i></strong>
        </Typography>
      </Container>
    </Box>
  );
}
